import { ZendeskConfig } from '../../config/defaultConfig';
import { Metadata, MetadataKey } from '../../services/metadata';

export type PrefilledField = {
  id: string;
  value: string;
};

const mapZendeskFieldsFromMetadata = (metadata: Metadata, config: ZendeskConfig): PrefilledField[] => {
  // Map our internal values to those required by Zendesk
  const zendeskKeysMap: Partial<Record<MetadataKey, string>> = {
    did: config.fieldsId.did,
    validationId: config.fieldsId.validationId,
    flowId: config.fieldsId.flowId,
  };

  const fields: PrefilledField[] = [];
  Object.keys(metadata).forEach((key: string) => {
    const metadataKey = key as MetadataKey;
    const metadataValue = metadata[metadataKey];
    const zendeskKey = zendeskKeysMap[metadataKey];
    if (metadataValue && zendeskKey) {
      fields.push({ id: zendeskKey, value: metadataValue });
    }
  });

  return fields;
};

export { mapZendeskFieldsFromMetadata };
